import { makeStyles } from "@mui/styles";

export const shareSiteStyles = makeStyles({
  closeButton: {
    fontSize: "14px",
    textTransform: "none",
    color: "#232128",
  },
});

export const stylesShareSite = {
  closeButton: {
    fontSize: "14px",
    textTransform: "none",
    color: "#232128",
  },

  selectPartner: {
    width: 430,
    maxWidth: "calc(100% - 20px)",
    marginTop: "24px",
  },

  filterInputs: {
    width: "220px",
  },
};
